import { defineComponent, h } from 'vue';
import { QField } from 'quasar';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';

export default defineComponent({
    name: 'form-controls-with-label-dsgn',
    components: {
        QField,
    },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        designmodel: null,
        schema: null,
        form: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
    },
    render() {
        const title = this.form?.title ?? this.designmodel.title;
        const hint = this.form?.description ?? this.designmodel.description;
        const controls = this.form?.Controls ?? this.designmodel.Controls ?? [];
        const items = [];

        for (let i = 0; i < controls.length; i++) {
            const c = controls[i];
            let DynamicControl = utils.getDesignerComponent(c, null);

            if (!c.$objectId) c.$objectId = utils.generateUUID();

            let id = `${i}_${c.$objectId}`;

            items.push(
                <DynamicControl
                    key={id}
                    type={c.ControlType}
                    name={c.ControlData ? c.ControlData.Name : ''}
                    root={this.root}
                    designmodel={c}
                    parentType="VerticalStack"
                    controlData={c.ControlData}
                    controlURL={c.ControlURL}
                    sourceData={this.cmodel}
                    sourceIndex={i}>
                </DynamicControl>
            );
        }

        return (
            <div
                class={{ 'designer-form': true }}
                style={{ marginLeft: (this.child * 15) + 'px', position: 'relative' }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QField
                    flat
                    outlined
                    stack-label
                    label={title}
                    hint={hint}
                >
                    <div style="display: flex; flex-direction: column;">
                        {items}
                    </div>
                </QField>
            </div>
        );
    }
});